module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholder":"Search Data","pendingInteractions":"Pending Interactions","dashboard":"Dashboards","dashboards":{"adaptive":"Adaptive","summary":"Summary"}},"es":{"placeholder":"Buscar Datos","pendingInteractions":"Interacciones Pendientes","dashboard":"Tableros","dashboards":{"adaptive":"Adaptables","summary":"Resumen"}}}')
  delete Component.options._Ctor
}
